import { lifeMapDefaultConfig, lifeMapPlugin } from './lifeMap'

export const graphTypePlugins = {
  lifeMap: lifeMapPlugin
}

export const graphTypeDefaultConfigs = {
  lifeMap: lifeMapDefaultConfig
}

export function getGraphTypePlugin (graphType) {
  return graphTypePlugins[graphType] || null
}

export function getGraphTypeDefaultConfig (graphType) {
  return graphTypeDefaultConfigs[graphType] || {}
}
